<ng-container>
    <fw-control-wrapper [Properties]="Properties"
                        [FormEditStyle]="FormEditStyle"
                        [AcceptChanges]="AcceptChanges"
                        [CustomFormGroup]="ChildFormGroup"></fw-control-wrapper>
</ng-container>